import React from 'react';

export type SparkleIconProps = React.SVGProps<SVGSVGElement>;

export const SparkleIcon: React.FC<SparkleIconProps> = (props) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <g clipPath="url(#SparkleIconClipPath)">
      <path
        d="M5.50872 1.40701C5.53014 1.29231 5.59101 1.18871 5.68077 1.11417C5.77053 1.03962 5.88354 0.99881 6.00022 0.99881C6.1169 0.99881 6.22991 1.03962 6.31967 1.11417C6.40943 1.18871 6.4703 1.29231 6.49172 1.40701L7.01722 4.18601C7.05454 4.38358 7.15056 4.56532 7.29274 4.70749C7.43491 4.84967 7.61665 4.94568 7.81422 4.98301L10.5932 5.50851C10.7079 5.52993 10.8115 5.59079 10.8861 5.68056C10.9606 5.77032 11.0014 5.88333 11.0014 6.00001C11.0014 6.11669 10.9606 6.2297 10.8861 6.31946C10.8115 6.40922 10.7079 6.47008 10.5932 6.49151L7.81422 7.01701C7.61665 7.05433 7.43491 7.15035 7.29274 7.29252C7.15056 7.4347 7.05454 7.61643 7.01722 7.81401L6.49172 10.593C6.4703 10.7077 6.40943 10.8113 6.31967 10.8858C6.22991 10.9604 6.1169 11.0012 6.00022 11.0012C5.88354 11.0012 5.77053 10.9604 5.68077 10.8858C5.59101 10.8113 5.53014 10.7077 5.50872 10.593L4.98322 7.81401C4.9459 7.61643 4.84988 7.4347 4.70771 7.29252C4.56553 7.15035 4.38379 7.05433 4.18622 7.01701L1.40722 6.49151C1.29252 6.47008 1.18893 6.40922 1.11438 6.31946C1.03983 6.2297 0.999023 6.11669 0.999023 6.00001C0.999023 5.88333 1.03983 5.77032 1.11438 5.68056C1.18893 5.59079 1.29252 5.52993 1.40722 5.50851L4.18622 4.98301C4.38379 4.94568 4.56553 4.84967 4.70771 4.70749C4.84988 4.56532 4.9459 4.38358 4.98322 4.18601L5.50872 1.40701Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 1V3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 2H9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2 11C2.55228 11 3 10.5523 3 10C3 9.44772 2.55228 9 2 9C1.44772 9 1 9.44772 1 10C1 10.5523 1.44772 11 2 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="SparkleIconClipPath">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

SparkleIcon.displayName = 'SparkleIcon';

export default SparkleIcon;
